import { get, post, put, del } from '@/Libs/Request/index';

const DOMAIN_NAME = '';
const NAME_SPACE = 'BASEINFO/';

export const fetchBaseInfo = (category, cb = () => {}) => {
  return (dispatch, getState) => {
    const strEx = 'dividers_id=' + (localStorage.getItem('dividersIdCurrent') || '');
    return get(`${DOMAIN_NAME}/api/baseinfo/${category}?${strEx}`)
      .then((res) => res.json())
      .then((json) => {
        if (json.errno !== 0) {
          return;
        }
        cb('', json.data);
        dispatch(receiveBaseinfoCollection(category, json.data));
        return Promise.resolve(json.data);
      });
  };
};

export const vLoading = (state) => ({
  type: NAME_SPACE + 'V_LOADING',
  payload: {
    state
  }
});

export const receiveBaseinfoCollection = (key, collection) => ({
  type: NAME_SPACE + 'RECEIVE_BASEINFO_COLLECTION',
  payload: {
    // key,
    [key]: collection
  }
});
